export const normalizeIds = (items: any[] = []): string[] =>
    items.map(item => {
      const idOrUri = typeof item === 'object' && '@id' in item ? item['@id'] : item;
      return typeof idOrUri === 'string' ? idOrUri.split('/').pop() : idOrUri;
    });

export const normalizeId = (input: any): string | null => {
        if (!input) return null;
      
        if (typeof input === 'string') {
          const parts = input.split('/');
          return parts[parts.length - 1] || null;
        }
      
        if (typeof input === 'object' && input['@id']) {
          const parts = input['@id'].split('/');
          return parts[parts.length - 1] || null;
        }
      
        return null;
      };